import { cn, PictogramIcon } from '@speedlo/ui'
import React from 'react'
import styled from 'styled-components/macro'

const StickerThemed = styled.div`
  background: ${({ theme }) => theme.primary};
  color: white;
  margin-top: 1rem;
  padding: 0;
  border-radius: 0 0.7rem 0.7rem 0;
  white-space: nowrap;
  flex: none;

  & p {
    display: inline-block;
    margin: 0.6rem 1rem 0 0;
    vertical-align: top;
    white-space: nowrap;
  }

  .icon {
    margin: 0.5rem 1rem 0;
  }
`

type TProps = {
  success?: boolean
}

export const Sticker: React.FC<TProps> = ({ success = false, children }) => (
  <StickerThemed
    className={cn('right__sticker', {
      'order-method-unselected': !success,
      'order-method-selected': success,
    })}
  >
    <PictogramIcon icon="transport" className="icon" size={1.8} inline />
    <p>{children}</p>
  </StickerThemed>
)
